'use strict';

const jQuery = require('jquery');

const container = require('./../core/container');
const DndZone = require('./../bundles/content/service/dndZone');
const ResizeColumn = require('./../bundles/content/service/resizeColumn');

const check = function() {
    let $toolbar = container.get('$toolbar');
    let $siteWrapper = container.get('$siteWrapper');
    let $containerSample = $toolbar.find('.container-sample');
    let isChanged = false;

    if ($containerSample.outerWidth() > (jQuery(window).width() - (parseInt(jQuery('.rootContentSet').css('padding-right') || 0, 10) * 2) - parseInt($siteWrapper.css('padding-left'), 10))) {
        if (!$siteWrapper.hasClass('cloud-container-fluid')) {
            $siteWrapper.addClass('cloud-container-fluid');
            isChanged = true;
        }
    } else {
        if ($siteWrapper.hasClass('cloud-container-fluid')) {
            $siteWrapper.removeClass('cloud-container-fluid');
            isChanged = true;
        }
    }

    if (isChanged) {
        DndZone.apply();
        ResizeColumn.apply();
    }
};


const init = function() {
    let $toolbar = container.get('$toolbar');
    let $containerSample = jQuery('<div class="container container-sample"></div>').css({'position': 'absolute', 'z-index': '-1'});

    $toolbar.append($containerSample);
    check();
};

module.exports.init = init;
module.exports.check = check;
